module.exports = __webpack_public_path__ + "static/media/bfile-condominium.6a1e8d35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-condominium.svg
// module id = 209
// module chunks = 0